import React from 'react';
import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';

import Create from './Children/Create';
import Dashboard from './Children/Dashboard';
import Terminals from './Children/Terminals';
import Update from './Children/Update';
import Info from './Children/Info';

export const UserRegistersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'userRegistersGroup',
      path: 'user-registers',
      scopes: getPermissionsForModule('Registry'),
      children: [
        {
          scopes: [Scopes.Registry.show],
          id: 'userRegistersGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          scopes: [Scopes.Registry.show],
          id: 'userRegistersGroup.terminals',
          path: '',
          element: <Terminals />,
        },
        {
          scopes: [Scopes.Registry.store],
          id: 'userRegistersGroup.create',
          path: 'create',
          element: <Create />,
        },
        {
          scopes: [Scopes.Registry.update],
          id: 'userRegistersGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Registry.show],
          id: 'userRegistersGroup.info',
          path: 'info',
          element: <Info />,
        },
      ],
    },
  ],
};
